
/*

- t: current time
- b: start value
- c: change in value
- d: duration

*/

const PI = 3.14159

/* eslint-disable no-param-reassign */
class Equation
{
    static linearTween(t, b, c, d)
    {
        return c * t / d + b
    }

    static easeInQuad(t, b, c, d)
    {
        t /= d
        return c * t * t + b
    }

    static easeOutQuad(t, b, c, d)
    {
        t /= d
        return -c * t * (t - 2) + b
    }

    static easeInOutQuad(t, b, c, d)
    {
        t /= d / 2
        if (t < 1) return c / 2 * t * t + b
        t--
        return -c / 2 * (t * (t - 2) - 1) + b
    }

    static easeInCubic(t, b, c, d)
    {
        t /= d
        return c * t * t * t + b
    }

    static easeOutCubic(t, b, c, d)
    {
        t /= d
        t--
        return c * (t * t * t + 1) + b
    }

    static easeInOutCubic(t, b, c, d)
    {
        t /= d / 2
        if (t < 1) return c / 2 * t * t * t + b
        t -= 2
        return c / 2 * (t * t * t + 2) + b
    }

    static easeInQuart(t, b, c, d)
    {
        t /= d
        return c * t * t * t * t + b
    }

    static easeOutQuart(t, b, c, d)
    {
        t /= d
        t--
        return -c * (t * t * t * t - 1) + b
    }

    static easeInOutQuart(t, b, c, d)
    {
        t /= d / 2
        if (t < 1) return c / 2 * t * t * t * t + b
        t -= 2
        return -c / 2 * (t * t * t * t - 2) + b
    }

    static easeInQuint(t, b, c, d)
    {
        t /= d
        return c * t * t * t * t * t + b
    }

    static easeOutQuint(t, b, c, d)
    {
        t /= d
        t--
        return c * (t * t * t * t * t + 1) + b
    }

    static easeInOutQuint(t, b, c, d)
    {
        t /= d / 2
        if (t < 1) return c / 2 * t * t * t * t * t + b
        t -= 2
        return c / 2 * (t * t * t * t * t + 2) + b
    }

    static easeInSine(t, b, c, d)
    {
        return -c * Math.cos(t / d * (PI / 2)) + c + b
    }

    static easeOutSine(t, b, c, d)
    {
        return c * Math.sin(t / d * (PI / 2)) + b
    }

    static easeInOutSine(t, b, c, d)
    {
        return -c / 2 * (Math.cos(PI * t / d) - 1) + b
    }

    static easeInExpo(t, b, c, d)
    {
        return c * Math.pow(2, 10 * (t / d - 1)) + b
    }

    static easeOutExpo(t, b, c, d)
    {
        return c * (-Math.pow(2, -10 * t / d) + 1) + b
    }

    static easeInOutExpo(t, b, c, d)
    {
        t /= d / 2
        if (t < 1) return c / 2 * Math.pow(2, 10 * (t - 1)) + b
        t--
        return c / 2 * (-Math.pow(2, -10 * t) + 2) + b
    }

    static easeInCirc(t, b, c, d)
    {
        t /= d
        return -c * (Math.sqrt(1 - t * t) - 1) + b
    }

    static easeOutCirc(t, b, c, d)
    {
        t /= d
        t--
        return c * Math.sqrt(1 - t * t) + b
    }

    static easeInOutCirc(t, b, c, d)
    {
        t /= d / 2
        if (t < 1) return -c / 2 * (Math.sqrt(1 - t * t) - 1) + b
        t -= 2
        return c / 2 * (Math.sqrt(1 - t * t) + 1) + b
    }
}

export default Equation



// WEBPACK FOOTER //
// ./src/scripts/utils/math/Equation.js